import type { PortfolioTaskQuestionResource } from "api/generated";
import type { TaskQuestion } from "portfolio/types";

export const taskQuestionFromDto = (
  resource: PortfolioTaskQuestionResource,
): TaskQuestion => ({
  id: resource.id,
  question: resource.question,
  type: resource.type,
  order: resource.order,
  required: resource.required,
  options: resource.options ?? [],
  createdAt: resource.created_at ? new Date(resource.created_at) : null,
  updatedAt: resource.updated_at ? new Date(resource.updated_at) : null,
  meta: {
    canUpdate: resource.meta.can_update,
    canDelete: resource.meta.can_delete,
  },
});
